/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import {  Button,   Dialog,   DialogActions,  DialogContent,  Grid, Box, Typography, IconButton, Divider, Chip, Stack, alpha} from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import {  AutoCompleteProdutoIdProduto,  BasicSelect,  IVFormErrors,  VFieldMoneyNumber2,  VFieldMoneyNumber4dn,  VForm,  VSwitchNumber,  VTextField, useVForm } from '../../../shared/forms';
import { AutoCompleteCfop } from '../../../shared/forms/AutoCompleteCfop';
import * as yup from 'yup';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InventoryIcon from '@mui/icons-material/Inventory';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';

interface IFormData {
  iditens: string;
  idprodutos: string;
  vfrete: number;
  voutros: number;
  vicmsst: number;
  ean: string;
  descricao: string;
  ncm: string;
  origem: number;
  cfop: number | null;
  un: string;
  untrib: string;
  qtd: number;
  qtdtrib: number;
  preco: number;
  precotrib: number;
  cst: string;
  vbc: number;
  picms: number;
  vicms: number;
  predbc: number;
  modbc: string;
  modbcst?: string;
  desconto: number;
  vseg: number;
  cstpis: string;
  picmsst: number;
  ppis: number;
  vipi: number;
  pipi: number;
  cstipi: string;
  vbcipi: number;
  vpis: number;
  vbcpis: number;
  cstcofins: string;
  vbccofins: number;
  pcofins: number;
  vcofins: number;
  bcicmsst: number;
  total: number;
  indtot: number;
  filtro: string;
}

export interface ConfirmationDialogRawProps {
  id: string;
  value: string;
  cfop: number;
  open: boolean;
  status: number;
  dados?: IFormData;
  onDados: (dados: IFormData) => void;
  onClose: (value?: string) => void;
}

const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'iditens' | 'descricao' | 'ncm' | 'ean' | 'origem'>> = yup.object().shape({
  bcicmsst: yup.number().min(0, 'bcicmsst não pode ser negativo').required(),
  cfop: yup.number().required('CFOP é obrigatório'),
  cst: yup.string().required('CST é obrigatório'), 
  idprodutos: yup.string().required('Produto é obrigatório'),
  cstcofins: yup.string().optional().default(''),
  cstipi: yup.string().optional().default(''),
  cstpis: yup.string().optional().default(''),
  desconto: yup.number().min(0).required(),
  indtot: yup.number().oneOf([0, 1], 'indtot deve ser 0 ou 1').required(),
  modbc: yup.string().optional().default(''),
  modbcst: yup.string().optional().default(''),
  pcofins: yup.number().min(0).required(),
  picms: yup.number().min(0).required(),
  picmsst: yup.number().min(0).required(),
  pipi: yup.number().min(0).required(),
  ppis: yup.number().min(0).required(),
  preco: yup.number().moreThan(0, 'Preço deve ser maior que zero').required(),
  precotrib: yup.number().moreThan(0, 'Preço tributável deve ser maior que zero').required(),
  predbc: yup.number().min(0).required(),
  qtd: yup.number().moreThan(0, 'Quantidade deve ser maior que zero').required(),
  qtdtrib: yup.number().moreThan(0, 'Quantidade tributável deve ser maior que zero').required(),
  total: yup.number().moreThan(0, 'Valor total deve ser maior que zero').required(),
  un: yup.string().required('Unidade é obrigatória'),
  untrib: yup.string().required('Unidade tributável é obrigatória'),
  vbc: yup.number().min(0).required(),
  vbccofins: yup.number().min(0).required(),
  vbcipi: yup.number().min(0).required(),
  vbcpis: yup.number().min(0).required(),
  vcofins: yup.number().min(0).required(),
  vfrete: yup.number().min(0).required(),
  vicms: yup.number().min(0).required(),
  vicmsst: yup.number().min(0).required(),
  vipi: yup.number().min(0).required(),
  voutros: yup.number().min(0).required(),
  vpis: yup.number().min(0).required(),
  vseg: yup.number().min(0).required(),
  filtro: yup.string().optional().default(''),
});

export const DialoNfe: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
  const { formRef, save } = useVForm();
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingicms, setIsLoadingicms] = useState(true);
  const [id, setId] = useState('');
  const [filtro, setfiltro] = useState('descricao');
  const [nomeprod, setNomeProd] = useState('');
  const [produtoid, setProdutoid] = useState('');
  const [unprod, setUnProd] = useState('');
  const [ncmprod, setNcmProd] = useState('');
  const [referencia, setreferencia] = useState<string | undefined>('');
  const [marca, setmarca] = useState<string | undefined>('');
  const [un, setun] = useState<string | undefined>('');
  const [origem, setOrigem] = useState<number >(0);
  const [ean, setEan] = useState<string >('');

  const guuid = uuidv4();

  const itensnovo: IFormData = {
    iditens: '',
    idprodutos: '',
    modbcst: '',
    vfrete: 0,
    voutros: 0,
    predbc: 0,
    modbc: '',
    vicmsst: 0,
    ean: '',
    descricao: '',
    ncm: '',
    origem: 0,
    cfop: null,
    picmsst: 0,
    un: '',
    untrib: '',
    qtd: 0,
    qtdtrib: 0,
    preco: 0,
    precotrib: 0,
    cst: '400',
    vbc: 0,
    picms: 0,
    vicms: 0,
    bcicmsst: 0,
    desconto: 0,
    vseg: 0,
    cstpis: '08',
    ppis: 0,
    vipi: 0,
    cstipi: '',
    vbcipi: 0,
    pipi: 0,
    vpis: 0,
    vbcpis: 0,
    cstcofins: '08',
    vbccofins: 0,
    pcofins: 0,
    vcofins: 0,
    total: 0,
    indtot: 1,
    filtro: 'descricao'

  };

  useEffect(() => {
    if (props.id === 'novo') {
      formRef.current?.setData({
        ...itensnovo,
        filtro: 'descricao'
       
      });
      setfiltro('descricao');
    } else {
      if (props.dados && typeof props.dados === 'object') {
        setNomeProd(props.dados.descricao);
        setNcmProd(props.dados.ncm);
        setUnProd(props.dados.un);
        formRef.current?.setData({
          ...props.dados,
          filtro: 'descricao' 
        });
        setfiltro('descricao'); 
      }
    }
  }, [id, formRef, open]); 
  useEffect(() => {
    if (open){
      setfiltro('descricao');
      setNomeProd('');
      setNcmProd('');
      setUnProd('');
      formRef.current?.setFieldValue('filtro', 'descricao');
    }
  }, [open, formRef]);
  const handleSave = (dados: IFormData) => {
    formValidationSchema
      .validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        if (props.id === 'novo') {
          props.onDados({
            iditens: guuid,
            descricao: nomeprod,
            ncm: ncmprod,
            ean: ean,
            origem: origem,
            ...dadosValidados
          });
        } else {
          props.onDados({
            iditens: props.id,
            descricao: nomeprod,
            ncm: ncmprod,
            ean: ean,
            origem: origem,
            ...dadosValidados
          });
        }
        onClose(value);
        setIsLoading(false);
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };
  const handleCancel = () => {
    onClose();
  };
  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    } else {
      setId(valueProp);
    }
  }, [valueProp, open]);
  const handleProd = (descricao: string | undefined) => {
    if (descricao != null) {
      setNomeProd(descricao);
    }
  };
  const handleidproduto = (idproduto: string | undefined) => {
    setProdutoid(idproduto ?? '');
    if (idproduto) {
      formRef.current?.setFieldValue('qtd', 1);
      formRef.current?.setFieldValue('qtdtrib', 1);
    } else {
      formRef.current?.setData({
        ...itensnovo,
        filtro,
      });
      setNomeProd('');
      setNcmProd('');
      setUnProd('');
      setEan('');
      setmarca('');
      setreferencia('');
      setOrigem(0);
    }
  };
  const handleun = (un: string | undefined) => {
    if (un != null) {
      setUnProd(un);
      formRef.current?.setFieldValue('un', un);
      formRef.current?.setFieldValue('untrib', un);
    }
  };
   const handleean = (ean: string | undefined) => {
    if (ean != null) {
      setEan(ean);
    }
  };
   const handleorigem = (origem: number | undefined) => {
    if (origem != null) {
      setOrigem(origem);
    }
  };
  const handlepreco = (preco: number | undefined) => {
    if (preco != null) {
      formRef.current?.setFieldValue('preco', preco);
      formRef.current?.setFieldValue('precotrib', preco);
      const data = formRef.current?.getData();
      const quantidade = Number(data?.qtd) || 1;
      formRef.current?.setFieldValue('total', preco * quantidade);
    }
  };
  const handlecfop = (cfop: number | undefined) => {
    if (cfop != null) {
      formRef.current?.setFieldValue('cfop', cfop);
    } else {
      formRef.current?.setFieldValue('cfop', null);
    }
  };
  const handlecalcularQtd = (valor: number | undefined) => {
    if (valor !== undefined && valor !== null) {
      const data = formRef.current?.getData();
      const preco = Number(data?.preco) || 0;
      const tvalor = valor * preco;
      formRef.current?.setFieldValue('qtdtrib', valor);
      formRef.current?.setFieldValue('total', tvalor);
    }
  };
  const handlebcimcs = (valor: number | undefined) => {
    if (valor !== undefined && valor !== null) {
      const data = formRef.current?.getData();
      const percentual = Number(data?.picms) || 0;
      const tvalor = (valor * percentual) / 100;
      formRef.current?.setFieldValue('vicms', tvalor);
    }
  };
  const handlepercentualicms = (valor: number | undefined) => {
    if (valor !== undefined && valor !== null) {
      const data = formRef.current?.getData();
      const bcicms = Number(data?.vbcicms) || 0;
      const tvalor = (valor * bcicms) / 100;
      formRef.current?.setFieldValue('vicms', tvalor);
    }
  };
  const handlecalcularPreco = (valor: number | undefined) => {
    if (valor !== undefined && valor !== null) {
      const data = formRef.current?.getData();
      const quantidade = data?.qtd || 0;
      const tvalor = valor * quantidade;
      formRef.current?.setFieldValue('precotrib', valor);
      formRef.current?.setFieldValue('total', tvalor);
    }
  };
  const handlecst = (valor: string | undefined) => {
    if (valor != null) {
      if (valor === '3' || valor === '4' || valor === '5') {
        formRef.current?.setFieldValue('vicms', 0);
        formRef.current?.setFieldValue('picms', 0);
        formRef.current?.setFieldValue('vbcicms', 0);
        formRef.current?.setFieldValue('cst', valor);
        setIsLoadingicms(true);
      } else {
        if (isLoading) {
          setIsLoadingicms(true);
        } else {
          setIsLoadingicms(false);
        }
      }
    }
  };
  const handleFiltro = (valor: string | undefined) => {
    if (valor != null) {
      setfiltro(valor);
      formRef.current?.setFieldValue('filtro', valor);
    }
  };
  const handlemarca = (valor: string | undefined) => {
    if (valor !== undefined) {
      setmarca(valor);
    }
  };
  const handlecstcofins = (valor: string | undefined) => {
    if (valor !== undefined) {
      formRef.current?.setFieldValue('cstcofins', valor);
    }
  };
  const handlecstipi = (valor: string | undefined) => {
    if (valor !== undefined) {
      formRef.current?.setFieldValue('cstipi', valor);
    }
  };
  const handlecstpis = (valor: string | undefined) => {
    if (valor !== undefined) {
      formRef.current?.setFieldValue('cstpis', valor);
    }
  };
  const handlencm = (valor: string | undefined) => {
    if (valor !== undefined) {
      setNcmProd(valor);
    }
  };
   const handlecsts = (valor: number | undefined) => {
    if (valor !== undefined) {
      formRef.current?.setFieldValue('cst', valor);
    }
  };
  const handlereferencia = (valor: string | undefined) => {
    setreferencia(valor);
  };
const handleUnChange = (valor: string | undefined) => {
  if (valor !== undefined && valor !== null) {
    formRef.current?.setFieldValue('untrib', valor);
    setUnProd(valor);
  }
};
  const renderProductTitle = () => {
    const productName = nomeprod || props.dados?.descricao || 'Novo Produto';
    const isEditing = props.id !== 'novo';
    return (
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 48,
            height: 48,
            borderRadius: '12px',
            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
            color: 'primary.main',
            border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
            flexShrink: 0,
            mt: 0.5,
          }}
        >
          {isEditing ? <EditIcon /> : <AddIcon />}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'text.primary' }}>
            {isEditing ? 'Editar Item da Nota Fiscal' : 'Novo Item da Nota Fiscal'}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography
              variant="body1"
              sx={{
                color: 'text.primary',
                fontWeight: 500,
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                whiteSpace: 'normal',
                lineHeight: 1.4,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {productName}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
              {isEditing && (
                <Chip
                  label="Editando"
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{
                    height: 22,
                    fontSize: '0.7rem',
                    borderWidth: '1px',
                    alignSelf: 'flex-start',
                  }}
                />
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };
  return (
    <Dialog
      open={open}
      {...other}
      sx={{ width: '100%' }}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
          maxWidth: '900px',
        }
      }}
    >
      <Box
        sx={{
          background: (theme) => theme.palette.background.paper,
          color: 'text.primary',
          position: 'relative',
          pt: 3,
          pb: 2,
          px: 3,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleCancel}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: 'text.secondary',
            backgroundColor: 'action.hover',
            '&:hover': {
              backgroundColor: 'action.selected',
              color: 'text.primary',
            }
          }}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        {renderProductTitle()}
        <Divider
          sx={{
            mt: 2,
            mb: 1.5,
          }}
        />

        <Stack direction="row" spacing={1} sx={{ mt: 1.5, flexWrap: 'wrap' }}>
          {props.dados?.un && (
            <Chip
              icon={<InventoryIcon sx={{ fontSize: 14 }} />}
              label={`UN: ${unprod}`}
              size="small"
              variant="outlined"
              sx={{
                height: 24,
                fontSize: '0.75rem',
                borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
                color: 'text.secondary',
                mb: 0.5,
              }}
            />
          )}
          {props.dados?.ncm && (
            <Chip
              label={`NCM: ${ncmprod}`}
              size="small"
              variant="outlined"
              sx={{
                height: 24,
                fontSize: '0.75rem',
                borderColor: (theme) => alpha(theme.palette.secondary.main, 0.3),
                color: 'text.secondary',
                mb: 0.5,
              }}
            />
          )}
          
        </Stack>
      </Box>
      <DialogContent dividers sx={{ p: 3 }}>
        <VForm ref={formRef} onSubmit={handleSave}placeholder={undefined} onPointerEnterCapture={undefined}onPointerLeaveCapture={undefined}>
          <Grid container direction="column">
            <Grid container item direction="row" padding={1} spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={2} >
                  <Grid item xs={12} sm={12} md={10} lg={8} xl={8}>
                    <AutoCompleteProdutoIdProduto
                      filtro={filtro}
                      isExternalLoading={props.status === 1 ? isLoading : true}
                      descricao={handleProd}
                      marca={handlemarca}
                      idproduto={handleidproduto}
                      referencia={handlereferencia}
                      un={handleun}
                      Cfop={handlecfop}
                      origem={handleorigem}
                      ean={handleean}
                      pVenda={handlepreco}
                      cst={handlecsts}
                      cstcofins={handlecstcofins}
                      cstipi={handlecstipi}
                      cstpis={handlecstpis}
                      ncm={handlencm}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='filtro'
                      label='Filtro'
                      aoClicar={handleFiltro}
                      data={[
                        { nameBD: 'descricao', descricao: 'Descrição' },
                        { nameBD: 'codbarraentrada', descricao: 'Código de Barras Entrada' },
                        { nameBD: 'referencia', descricao: 'Referência' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='un'
                      label='Unidade'
                      disabled={props.status === 1 ? isLoading : true}
                      onChange={(e) => handleUnChange(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='untrib'
                      label='Unidade Tributada'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
                    <VSwitchNumber
                      name='indtot'
                      label='Ind. Total'
                      fdisabled={props.status === 1 ? isLoading : true}
                      aliamento='top'
                     
                    />
                  </Grid>

                  <Grid item xs={8} sm={8} md={6} lg={6} xl={6}>
                    <AutoCompleteCfop 
                    isExternalLoading={props.status === 1 ? isLoading : true }
                     />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='qtd'
                      label='Quantidade'
                      disabled={props.status === 1 ? isLoading : true}
                      calcular={handlecalcularQtd}
                      
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='qtdtrib'
                      label='Quantidade Tributada'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='preco'
                      label='Preço Unitario'
                      disabled={props.status === 1 ? isLoading : true}
                      calcular={handlecalcularPreco}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='precotrib'
                      label='Preço Tributado'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                   <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='total'
                      label='Valor Total'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='cst'
                      label='Cst'
                      aoClicar={handlecst}
                      data={[
                        { nameBD: '101', descricao: '101' },
                        { nameBD: '102', descricao: '102' },
                        { nameBD: '103', descricao: '103' },
                        { nameBD: '203', descricao: '203' },
                        { nameBD: '300', descricao: '300' },
                        { nameBD: '400', descricao: '400' },
                        { nameBD: '500', descricao: '500' },
                        { nameBD: '900', descricao: '900' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='modbc'
                      label='Mod BC'
                      data={[
                        { nameBD: '0', descricao: '0 - Margem Valor Agregado (%)' },
                        { nameBD: '1', descricao: '1 - Pauta (Valor)' },
                        { nameBD: '2', descricao: '2 - Preço Tabelado Máx. (valor)' },
                        { nameBD: '3', descricao: '3 - Valor da operação' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                   <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='picms'
                      label='Percentual'
                      calcular={handlepercentualicms}
                      disabled={isLoadingicms}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='predbc'
                      label='P. Redução ICMS'
                      disabled={isLoadingicms}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vicms'
                      label='Valor ICMS'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='cstipi'
                      label='CST IPI'
                      data={[
                        { nameBD: '', descricao: 'vazio' },
                        { nameBD: '00', descricao: '00' },
                        { nameBD: '49' , descricao: '49' },
                        { nameBD: '50', descricao: '50' },
                        { nameBD: '99' , descricao: '99' },
                        { nameBD: '01', descricao: '01' },
                        { nameBD: '02', descricao: '02' },
                        { nameBD: '03', descricao: '03' },
                        { nameBD: '04', descricao: '04' },
                        { nameBD: '05', descricao: '05' },
                        { nameBD: '51', descricao: '51' },
                        { nameBD: '52' , descricao: '52' },
                        { nameBD: '53' , descricao: '53' },
                        { nameBD: '54', descricao: '54' },
                        { nameBD: '55', descricao: '55' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='vbcipi'
                      label='B.C IPI'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='pipi'
                      label='Percentual IPI'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='vipi'
                      label='Valor IPI'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='vfrete'
                      label='Frete'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='desconto'
                      label='Desconto'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='cstpis'
                      label='CST PIS'
                      data={[
                        { nameBD: '01', descricao: '01' },
                        { nameBD: '02', descricao: '02' },
                        { nameBD: '03', descricao: '03' },
                        { nameBD: '04', descricao: '04' },
                        { nameBD: '05', descricao: '05' },
                        { nameBD: '06', descricao: '06' },
                        { nameBD: '07', descricao: '07' },
                        { nameBD: '08', descricao: '08' },
                        { nameBD: '09', descricao: '09' },
                        { nameBD: '49', descricao: '49' },
                        { nameBD: '50', descricao: '50' },
                        { nameBD: '51', descricao: '51' },
                        { nameBD: '52', descricao: '52' },
                        { nameBD: '53', descricao: '53' },
                        { nameBD: '55', descricao: '55' },
                        { nameBD: '56', descricao: '56' },
                        { nameBD: '60', descricao: '60' },
                        { nameBD: '61', descricao: '61' },
                        { nameBD: '62', descricao: '62' },
                        { nameBD: '63', descricao: '63' },
                        { nameBD: '64', descricao: '64' },
                        { nameBD: '65', descricao: '65' },
                        { nameBD: '66', descricao: '66' },
                        { nameBD: '67', descricao: '67' },
                        { nameBD: '70', descricao: '70' },
                        { nameBD: '71', descricao: '71' },
                        { nameBD: '72', descricao: '72' },
                        { nameBD: '73', descricao: '73' },
                        { nameBD: '74', descricao: '74' },
                        { nameBD: '75', descricao: '75' },
                        { nameBD: '98', descricao: '98' },
                        { nameBD: '99', descricao: '99' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='vbcpis'
                      label='B.C PIS'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='ppis'
                      label='Percentual PIS'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='vpis'
                      label='Valor PIS'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='vbc'
                      label='Base De Calculo'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='voutros'
                      label='Outros Valor'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='vseg'
                      label='Seguro'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='cstcofins'
                      label='CST CONFIS'
                      data={[
                        { nameBD: '01', descricao: '01' },
                        { nameBD: '02', descricao: '02' },
                        { nameBD: '03', descricao: '03' },
                        { nameBD: '04', descricao: '04' },
                        { nameBD: '05', descricao: '05' },
                        { nameBD: '06', descricao: '06' },
                        { nameBD: '07', descricao: '07' },
                        { nameBD: '08', descricao: '08' },
                        { nameBD: '09', descricao: '09' },
                        { nameBD: '49', descricao: '49' },
                        { nameBD: '50', descricao: '50' },
                        { nameBD: '51', descricao: '51' },
                        { nameBD: '52', descricao: '52' },
                        { nameBD: '53', descricao: '53' },
                        { nameBD: '55', descricao: '55' },
                        { nameBD: '56', descricao: '56' },
                        { nameBD: '60', descricao: '60' },
                        { nameBD: '61', descricao: '61' },
                        { nameBD: '62', descricao: '62' },
                        { nameBD: '53', descricao: '63' },
                        { nameBD: '64', descricao: '64' },
                        { nameBD: '65', descricao: '65' },
                        { nameBD: '66', descricao: '66' },
                        { nameBD: '67', descricao: '67' },
                        { nameBD: '70', descricao: '70' },
                        { nameBD: '71', descricao: '71' },
                        { nameBD: '72', descricao: '72' },
                        { nameBD: '73', descricao: '73' },
                        { nameBD: '74', descricao: '74' },
                        { nameBD: '75', descricao: '75' },
                        { nameBD: '98', descricao: '98' },
                        { nameBD: '99', descricao: '99' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='vbccofins'
                      label='B.C CONFIS'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='pcofins'
                      label='Percentual CONFIS'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='vcofins'
                      label='Valor CONFIS'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='modbcst'
                      label='Mod BC ST'
                      data={[
                        { nameBD: '0', descricao: '0 - Preço tabelado ou máximo sugerido' },
                        { nameBD: '1', descricao: '1 - Lista Negativa (valor)' },
                        { nameBD: '2', descricao: '2 - Lista Positiva (valor)' },
                        { nameBD: '3', descricao: '3 - Lista Neutra (valor)' },
                        { nameBD: '4', descricao: '4 - Margem Valor Agregado (%)' },
                        { nameBD: '5', descricao: '5 - Pauta (valor)' },
                        { nameBD: '6', descricao: '6 - Valor da Operação' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='bcicmsst'
                      label='B.C ICMS ST'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='picmsst'
                      label='Percentual ST'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='vicmsst'
                      label='Valor ICMS ST'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </VForm>
      </DialogContent>
      <DialogActions sx={{ 
        p: 2.5, 
        pt: 2,
        backgroundColor: 'background.default',
        borderTop: 1,
        borderColor: 'divider'
      }}>
        <Stack 
          direction="row" 
          spacing={1.5} 
          sx={{ 
            width: '100%',
            justifyContent: 'flex-end'
          }}
        >
          <Button
            variant="outlined"
            onClick={handleCancel}
            startIcon={<CancelIcon />}
            sx={{
              px: 2.5,
              py: 0.75,
              borderRadius: '8px',
              borderColor: 'grey.300',
              color: 'grey.700',
              fontWeight: 500,
              textTransform: 'none',
              fontSize: '0.875rem',
              '&:hover': {
                borderColor: 'error.main',
                backgroundColor: (theme) => alpha(theme.palette.error.main, 0.04),
                color: 'error.main',
              }
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            disabled={props.status === 1 ? isLoading : true}
            onClick={save}
            startIcon={<CheckCircleIcon />}
            sx={{
              px: 2.5,
              py: 0.75,
              borderRadius: '8px',
              backgroundColor: 'primary.main',
              color: 'white',
              fontWeight: 500,
              textTransform: 'none',
              fontSize: '0.875rem',
              '&:hover': {
                backgroundColor: 'primary.dark',
                boxShadow: (theme) => `0 4px 12px ${alpha(theme.palette.primary.main, 0.2)}`,
              },
              '&:disabled': {
                backgroundColor: 'action.disabledBackground',
                color: 'action.disabled',
                boxShadow: 'none',
              }
            }}
          >
            Confirmar
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};